import { AbstractControl, ValidationErrors } from '@angular/forms';

export function SpanishIdValidator(control: AbstractControl): any {

  const vat = control.get('vat').value;
  const ignoreVatValidation = control.get('ignoreVatValidation').value;

  let errorsVat = { vatIsInvalid: false };
  
  if (!vat)
      errorsVat = { vatIsInvalid: false }
  else if (!ignoreVatValidation && !SpanishIdisValid(vat) === true)
    errorsVat = { vatIsInvalid: true };

  control.get('vat').setErrors(errorsVat);

}

export function SpanishIdisValid (value: any): boolean | null {

  if (!value) return null;

  if (typeof value !== 'string') return false;

  const ucValue = value.toUpperCase().replace(/\s/g, '');

  if (validateNIF(ucValue) || validateNIE(ucValue) || validateCIF(ucValue)) {
    return true;
  }

  return false ;
}

/* ===================== NIF ===================== */

function validateNIF(nif: string): boolean {
  const regex = /^(\d{8})([A-Z])$/;
  const match = nif.match(regex);
  if (!match) return false;

  const number = parseInt(match[1], 10);
  const letter = match[2];

  const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  return letters[number % 23] === letter;
}

/* ===================== NIE ===================== */

function validateNIE(nie: string): boolean {
  const regex = /^[XYZ]\d{7}[A-Z]$/;
  if (!regex.test(nie)) return false;

  const prefix = nie[0];
  const number = nie.substring(1, 8);
  const letter = nie[8];

  const prefixMap = { X: '0', Y: '1', Z: '2' };
  const fullNumber = parseInt(prefixMap[prefix] + number, 10);

  const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  return letters[fullNumber % 23] === letter;
}

/* ===================== CIF ===================== */

function validateCIF(cif: string): boolean {
  const regex = /^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/;
  if (!regex.test(cif)) return false;

  const control = cif[cif.length - 1];
  const digits = cif.substring(1, 8);

  let sumA = 0;
  let sumB = 0;

  for (let i = 0; i < digits.length; i++) {
    const n = parseInt(digits[i], 10);

    if (i % 2 === 0) {
      let tmp = n * 2;
      if (tmp > 9) tmp -= 9;
      sumA += tmp;
    } else {
      sumB += n;
    }
  }

  const total = sumA + sumB;
  const unit = (10 - (total % 10)) % 10;

  const controlLetters = 'JABCDEFGHI';

  if (/[PQRSNW]/.test(cif[0])) {
    return controlLetters[unit] === control;
  }

  if (/[ABEH]/.test(cif[0])) {
    return unit.toString() === control;
  }

  return unit.toString() === control || controlLetters[unit] === control;
}